<template>
   <div>
      <div class="row mb-4">
         <div class="col">
            <div class="card border-left-warning shadow h-100 py-2">
               <div class="card-body">
                  <form action="" @submit.prevent="getData">
                     <div class="row">
                        <div class="col">
                           <div class="row">
                              <div class="col">
                                 <select class="form-control" v-model="year" aria-placeholder="السنة">
                                    <option value="2021">2021</option>
                                    <option value="2022">2022</option>
                                 </select>
                              </div>
                              <div class="col">
                                 <select class="form-control" v-model="month" aria-placeholder="الشهر">
                                    <option value="01">01</option>
                                    <option value="02">02</option>
                                    <option value="03">03</option>
                                    <option value="04">04</option>
                                    <option value="05">05</option>
                                    <option value="06">06</option>
                                    <option value="07">07</option>
                                    <option value="08">08</option>
                                    <option value="09">09</option>
                                    <option value="10">10</option>
                                    <option value="11">11</option>
                                    <option value="12">12</option>
                                 </select>
                              </div>
                           </div>
                        </div>
                        <div class="col-auto">
                           <button type="submit" class="btn btn-success">
                              <i class="fas fa-search"></i>
                           </button>
                        </div>
                     </div>
                  </form>
               </div>
            </div>
         </div>
      </div>

      <div class="row" v-if="loading">
         <div class="col">
            <div class="big-loader text-center pt-50 pb-50">
               <loader />
            </div>
         </div>
      </div>

      <div class="card shadow mb-4" v-if="!loading">
         <div class="card-header py-3">
            <h6 class="m-0 font-weight-bold text-primary">مطاعم وكافيهات</h6>
         </div>

         <div class="card-body">
            <div class="row mb-5">
               <div class="col">
                  <DataTable
                     title="طلبات المطاعم والكافيهات المكتملة بنجاح"
                     :columns="tableColums"
                     :rows="data.places"
                     :exportable="true"
                     v-if="data.places"
                  />
               </div>
            </div>
         </div>
      </div>
   </div>
</template>

<script>
   import DataTable from "vue-materialize-datatable";

   export default 
   {
      name: "PlacesReport",
      components: {
         DataTable
      },
      data(){
         return {
            loading: true,
            breadcrum: {
               "/": "الرئيسية",
               "#": "تقرير المطاعم",
            },
            year: "",
            month: "",
            data: {},
            tableColums: [
               {
                  label: "الاسم",
                  field: "name",
                  numeric: false,
                  html: false
               },
               {
                  label: "حالة التعاقد",
                  field: "contract",
                  numeric: false,
                  html: false
               },
               {
                  label: "عدد الطلبات",
                  field: "orders",
                  numeric: true,
                  html: false
               },
               {
                  label: "قيمة المشتريات",
                  field: "invoice_amount",
                  numeric: true,
                  html: false
               },
            ],
         }
      },
      methods: {
         getData(){
            this.loading = true;
            this.$store.commit("SET_ERROR", "");
            this.$http.get("/api/reports/places/" + this.year + this.month).then(response => {
               this.loading = false;
               this.data = response.data;
            }).catch(err => {
               this.$store.commit("SET_ERROR", err.data.error);
            });
         },
      },
      created(){
         this.$store.commit("SET_ACTIVE_MENU", "places_report");
         this.$store.commit("SET_BREADCRUMB", this.breadcrum);
         this.$store.commit("SET_ERROR", "");
         this.$store.commit("SET_SUCCESS", "");
         this.$store.commit("SET_TITLE", "تقرير المطاعم");
         
         let date = new Date();
         this.year = date.getFullYear();
         if(date.getMonth() < 10){
            this.month = `0${date.getMonth()+1}`;
         }else{
            this.month = date.getMonth()+1;
         }
         
         this.getData();
      }
   }
</script>